<script setup lang="ts">
interface EducationItem {
  school: string
  major: string
  period: string
  description?: string
  highlights?: string[]
}

const { data: educationDoc } = await useAsyncData('education', () =>
  queryCollection('education').first()
)

const education = computed(() => ((educationDoc.value as { items?: EducationItem[] } | null)?.items ?? []) as EducationItem[])
</script>

<template>
  <section
    id="education"
    class="py-12"
  >
    <h2 class="text-xs font-semibold uppercase tracking-widest text-muted mb-6">
      Education
    </h2>

    <div class="space-y-4">
      <div
        v-for="(edu, index) in education"
        :key="index"
        class="p-4 rounded-xl border border-default bg-elevated"
      >
        <div class="flex items-start justify-between gap-4 mb-1">
          <h3 class="font-semibold text-highlighted text-base">
            {{ edu.school }}
          </h3>
          <span class="text-sm text-muted shrink-0">{{ edu.period }}</span>
        </div>
        <p class="text-sm font-medium text-muted mb-2">
          {{ edu.major }}
        </p>
        <p class="text-sm text-muted leading-relaxed mb-3">
          {{ edu.description }}
        </p>

        <ul class="space-y-1">
          <li
            v-for="highlight in edu.highlights"
            :key="highlight"
            class="flex items-start gap-2 text-sm text-muted"
          >
            <UIcon
              name="i-lucide-check"
              class="text-primary mt-0.5 shrink-0 size-3"
            />
            {{ highlight }}
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
